import {combineReducers} from 'redux'
import authReducer from './auth.reducer';
import titleReducer from './title.reducer';

import dataReducer from './data.reducer';

const RootReducer = combineReducers({
    title: titleReducer,
    auth:authReducer,
    loader:dataReducer
});

export default RootReducer